import React from 'react';
import { Card, Form, Row, Col } from 'react-bootstrap';

const EventSchedule = ({ formData, handleFormChange }) => {
  return (
    <Card className="dark-main-card text-light">
      <Card.Body className="p-3 compact-form">
        <h3 className="mb-3 text-white" style={{ fontSize: "1.5rem" }}>Event Schedule</h3>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-2" controlId="eventStartDate">
              <Form.Label>Event Start Date/Time</Form.Label>
              <Form.Control
                type="datetime-local"
                name="eventStartDate"
                value={formData.eventStartDate}
                onChange={handleFormChange}
                className="dark-input"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-2" controlId="eventEndDate">
              <Form.Label>Event End Date/Time</Form.Label>
              <Form.Control
                type="datetime-local"
                name="eventEndDate"
                value={formData.eventEndDate}
                onChange={handleFormChange}
                className="dark-input"
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-2" controlId="setupStartTime">
              <Form.Label>Setup Start Time</Form.Label>
              <Form.Control
                type="datetime-local"
                name="setupStartTime"
                value={formData.setupStartTime}
                onChange={handleFormChange}
                className="dark-input"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-2" controlId="teardownEndTime">
              <Form.Label>Teardown End Time</Form.Label>
              <Form.Control
                type="datetime-local"
                name="teardownEndTime"
                value={formData.teardownEndTime}
                onChange={handleFormChange}
                className="dark-input"
              />
            </Form.Group>
          </Col>
        </Row>
        <Form.Group className="mb-2" controlId="timeZone">
          <Form.Label>Time Zone</Form.Label>
          <Form.Select
            name="timeZone"
            value={formData.timeZone}
            onChange={handleFormChange}
            className="dark-input"
          >
            <option value="">Select Time Zone</option>
            <option value="UTC">UTC</option>
            <option value="EST">EST</option>
            <option value="PST">PST</option>
          </Form.Select>
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export default EventSchedule;